import { BodyText, Form, FormInputProps, Icon, Stack } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC, useState } from 'react';
import { MultipleValidator } from '../../utils/multiple.validator';
import * as Styles from './password.input.module.less';

export const passwordError = (validator: MultipleValidator, error?: string) => {
    const errorMap = validator.errorMap(error);

    if (!errorMap) {
        return error;
    }

    return (
        <Stack direction="column">
            {Object.keys(errorMap).map(error => (
                <BodyText
                    key={error}
                    className={errorMap[error] ? 'c-red-500' : 'c-green-500'}
                    size="small"
                >
                    <Icon
                        name={errorMap[error] ? 'error' : 'check'}
                        size={14}
                        className="m-r-half"
                    />
                    {error}
                </BodyText>
            ))}
        </Stack>
    );
};

export const PasswordInput: FC<FormInputProps> = props => {
    const [visible, setVisible] = useState(false);
    const handleIconClick = () => {
        setVisible(prev => !prev);
    };

    return (
        <Form.Input
            icon={{ name: visible ? 'visibility' : 'visibility_off', onClick: handleIconClick }}
            type={visible ? 'text' : 'password'}
            {...props}
            className={classNames(Styles.input, props.className)}
            autoComplete="current-password"
        />
    );
};
